
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Urbaniaonrentinpune() {



    const cardData =
    {
        keyword: 'Urbania On Rent in Pune ',
        heading: 'Amruta Travels: Urbania On Rent in Pune',
        headingDescription: 'Amruta Travels offers Urbania on Rent in Pune, providing a luxurious and comfortable transportation solution for all your travel needs. Whether you are planning a corporate event, family trip, wedding, or group tour, our well-maintained Force Urbania vans ensure a smooth and enjoyable journey. Choose from our range of Urbania vans, including 10-seater, 13-seater, and 17-seater options, to suit your group size. With experienced drivers, punctual service, affordable pricing, and 24/7 availability, Amruta Travels makes your travel in and around Pune simple and stress-free',


        top: 'Top Places to Visit in Outstation Pune with Amruta Travels',



"topPlaces": [
  {
    "title": "Lonavala & Khandala",
    "description": "Located approximately 66 km from Pune, these twin hill stations are nestled in the Sahyadri ranges. Known for their lush green valleys, waterfalls, and pleasant climate, they offer attractions like Bhushi Dam, Tiger's Leap, and Rajmachi Fort. Adventure enthusiasts can indulge in trekking, camping, and paragliding activities."
  },
  {
    "title": "Mahabaleshwar & Panchgani",
    "description": "Situated about 120 km from Pune, Mahabaleshwar is renowned for its strawberry farms, scenic viewpoints like Arthur's Seat, and the serene Venna Lake. Nearby Panchgani, at a distance of 100 km, offers attractions like Table Land and Parsi Point. Both hill stations provide a refreshing escape from city life."
  },
  {
    "title": "Matheran",
    "description": "Approximately 120 km from Pune, Matheran is India's smallest hill station and is unique for being a vehicle-free zone. Perched at an elevation of 800 meters, it offers panoramic views, colonial architecture, and 38 designated viewpoints, including Panorama Point and Louisa Point."
  },
  {
    "title": "Alibaug",
    "description": "Located around 140 km from Pune, Alibaug is a coastal town known for its clean beaches like Alibaug Beach and Nagaon Beach, as well as historical sites like Kolaba Fort. It's a popular destination for beach lovers and those seeking a tranquil seaside retreat."
  },
  {
    "title": "Kolad",
    "description": "Approximately 110 km from Pune, Kolad is famed for white-water rafting on the Kundalika River. The town also offers opportunities for kayaking, zip-lining, and camping, making it a haven for adventure seekers."
  },
  {
    "title": "Igatpuri",
    "description": "Situated about 240 km from Pune, Igatpuri is a hill station in the Western Ghats known for its misty mountains, waterfalls, and the Vipassana International Academy. It's an ideal spot for meditation, trekking, and enjoying nature's tranquility."
  },
  {
    "title": "Bhandardara",
    "description": "Located roughly 170 km from Pune, Bhandardara is a serene village offering attractions like the Bhandardara Lake, Randha Falls, and the historic Ratangad Fort. It's a perfect destination for nature lovers and those seeking solitude."
  },
  {
    "title": "Lavasa",
    "description": "Approximately 60 km from Pune, Lavasa is a planned city inspired by the Italian town of Portofino. It offers picturesque landscapes, water sports, and a range of dining options, making it a popular spot for weekend retreats."
  },
  {
    "title": "Goa",
    "description": "Situated about 450 km from Pune, Goa is India's premier beach destination. Known for its vibrant nightlife, Portuguese heritage, and sandy beaches like Baga and Anjuna, it offers a mix of relaxation and entertainment."
  },
  {
    "title": "Kaas Plateau",
    "description": "Around 140 km from Pune, the Kaas Plateau, also known as the 'Valley of Flowers of Maharashtra,' is a UNESCO World Natural Heritage site. During the monsoon season, it blooms with a variety of endemic flowers, attracting nature enthusiasts and photographers."
  }
],


    "services": [
    {
      "name": "Urbania On Rent in Pune",
      "description": "Amruta Travels offers Urbania vehicles on rent in Pune for a smooth, premium travel experience. Ideal for small group trips, corporate visits, and family outings, our Urbania vans feature AC, pushback seats, and modern interiors. Book online for convenient and reliable travel."
    },
    {
      "name": "Force Urbania On Rent In Pune",
      "description": "Looking for a comfortable travel option in Pune? Amruta Travels provides Force Urbania vans on rent with spacious seating, AC, and a professional driver. Suitable for city tours, airport transfers, and corporate group movement."
    },
    {
      "name": "Force Urbania on Rent in Kothrud",
      "description": "Amruta Travels offers Force Urbania rentals in Kothrud, Pune for local and outstation travel. Great for weddings, school picnics, and group airport drop-offs. Choose from 13 to 17-seater options with well-maintained interiors and AC comfort."
    },
    {
      "name": "Force Urbania for Rent in Pune",
      "description": "Rent a Force Urbania in Pune with Amruta Travels for convenient, compact group travel. Equipped with luxury features, these mini-buses are perfect for city tours, Pune Darshan, and executive transfers. Easy online booking and expert chauffeurs included."
    },
    {
      "name": "Force Urbania 17 Seater for Rent",
      "description": "Amruta Travels provides Force Urbania 17-seater vans on rent in Pune, ideal for mid-sized group travel. Enjoy air-conditioning, high-roof comfort, and ergonomic seating for long-distance journeys or daily office transport."
    },
    {
      "name": "Force Urbania for Rent Near Me Pune",
      "description": "Find a Force Urbania for rent near you in Pune with Amruta Travels. We serve all major areas including Kothrud, Baner, and Viman Nagar with doorstep pickup, trained drivers, and smooth, air-conditioned travel experiences."
    },
    {
      "name": "Force Urbania Per Km Rate",
      "description": "Amruta Travels offers competitive per km rates for Force Urbania rentals in Pune. Perfect for budget-conscious travel without compromising on comfort. Transparent pricing and no hidden charges—contact us for a detailed quote."
    },
    {
      "name": "Force Urbania Luxury Mini Bus On Rent",
      "description": "Book a luxury Force Urbania mini-bus with Amruta Travels for premium travel across Pune. Enjoy leather interiors, powerful AC, and extra legroom. Ideal for celebrity transport, weddings, or corporate executives."
    },
    {
      "name": "Force Urbania on Rent in Karve Nagar",
      "description": "Get Force Urbania on rent in Karve Nagar from Amruta Travels. Whether it's family trips, Pune Darshan, or corporate commutes, our Urbania vans are maintained for both comfort and safety. Quick online booking available."
    },
    {
      "name": "Luxury Force Urbania on Rent in Pune",
      "description": "Travel in style with Amruta Travels' luxury Force Urbania rentals in Pune. These high-end mini-buses are perfect for premium transport needs, offering plush interiors, professional chauffeurs, and all modern amenities."
    },
    {
      "name": "Urbania on Rent in Viman Nagar",
      "description": "Amruta Travels provides Urbania vans for rent in Viman Nagar, ideal for airport transfers, weekend getaways, and Pune sightseeing. Enjoy clean, AC interiors, trained drivers, and flexible rental durations."
    },
    {
      "name": "Urbania on Rent in Koregaon Park Pune",
      "description": "Hire an Urbania in Koregaon Park with Amruta Travels for stylish and dependable group travel. Our luxury Urbanias are best suited for guests, VIPs, or executive groups needing safe, smooth, and comfortable transport."
    },
    {
      "name": "Force Urbania on Rent in Kalyani Nagar",
      "description": "Rent a Force Urbania in Kalyani Nagar with Amruta Travels for luxury commuting. Perfect for outstation trips, airport transfers, and premium client pickups with all comforts included."
    },
    {
      "name": "Urbania on Rent in Kharadi",
      "description": "Amruta Travels offers Force Urbania vans for rent in Kharadi for business events, school tours, or family transport. Fully sanitized, driver-assisted, and available with hourly and daily rental options."
    },
    {
      "name": "Urbania on Rent in Hadapsar",
      "description": "Looking for reliable Urbania rental in Hadapsar? Amruta Travels provides mini-bus options for corporate pick-ups, leisure travel, or religious tours. Book effortlessly with transparent pricing and guaranteed comfort."
    },
    {
      "name": "Urbania on Rent in Garden Pune",
      "description": "Amruta Travels offers Force Urbania rentals near Garden area, Pune. Whether you're heading out for Pune Darshan or a weekend getaway, our air-conditioned, clean, and safe Urbania vehicles are ready to serve."
    },
    {
      "name": "Urbania on Rent for Pune Darshan",
      "description": "Explore Pune comfortably with Amruta Travels' Urbania vans on rent for city sightseeing. Perfect for small tourist groups, this service includes an experienced driver, AC interiors, and enough space for hassle-free movement around all key spots."
    },
    {
      "name": "Urbania on Rent in Katraj",
      "description": "Hire Urbania vans from Amruta Travels in Katraj for weddings, college tours, or group airport transfers. These 13–17 seater vehicles come with comfortable seating, AC, and easy pickup/drop in your locality."
    },
    {
      "name": "Urbania Rental Near Me Contact Number",
      "description": "Looking to rent a Force Urbania nearby in Pune? Contact Amruta Travels today for bookings, prices, and availability. We serve all major Pune localities with on-demand service and dedicated support. Call us for instant assistance."
    }
  ],
  "tableData": [
    ["Urbania On Rent in Pune", "Force Urbania On Rent In Pune"],
    ["Force Urbania on Rent in Kothrud", "Force Urbania for Rent in Pune"],
    ["Force Urbania 17 Seater for Rent", "Force Urbania for Rent Near Me Pune"],
    ["Force Urbania Per Km Rate", "Force Urbania Luxury Mini Bus On Rent"],
    ["Force Urbania on Rent in Karve Nagar", "Luxury Force Urbania on Rent in Pune"],
    ["Urbania on Rent in Viman Nagar", "Urbania on Rent in Koregaon Park Pune"],
    ["Force Urbania on Rent in Kalyani Nagar", "Urbania on Rent in Kharadi"],
    ["Urbania on Rent in Hadapsar", "Urbania on Rent in Garden Pune"],
    ["Urbania on Rent for Pune Darshan", "Urbania on Rent in Katraj"],
    ["Urbania Rental Near Me Contact Number", ""]
  ],





"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Spacious Urbania Vans for Rent in Pune",
    "WhyChoosedescription": "Amruta Travels offers well-maintained Urbania vans on rent in Pune, perfect for group travel with family, friends, or colleagues. Known for their spacious interiors and modern design, Urbania vans provide a comfortable and stylish way to travel across the city or on outstation trips."
  },
  {
    "WhyChooseheading": "Ideal for Family Trips, Corporate Travel, and Airport Transfers",
    "WhyChoosedescription": "Urbania vans are a great choice for various travel needs including family vacations, business travel, wedding events, or airport pickups and drops. With flexible seating options and ample luggage space, these vans offer both functionality and luxury."
  },
  {
    "WhyChooseheading": "Premium Features for a Luxurious Ride",
    "WhyChoosedescription": "Our Urbania vehicles come equipped with modern features such as plush reclining seats, air conditioning, ambient lighting, USB charging points, and high-quality suspension systems. Passengers enjoy a smooth, relaxed journey every time."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Rental Packages",
    "WhyChoosedescription": "We offer cost-effective rental plans for Urbania vans in Pune with transparent pricing. All charges—fuel, tolls, driver allowance, and taxes—are included upfront. No hidden fees, so you can book confidently and stick to your travel budget."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our Urbania rentals include trained and courteous drivers who ensure a safe, punctual, and pleasant travel experience. They are familiar with Pune’s routes and major outstation destinations, making your ride hassle-free and enjoyable."
  },
  {
    "WhyChooseheading": "Perfect for Local and Outstation Trips",
    "WhyChoosedescription": "Urbania vans are ideal for both short city commutes and long-distance travel. Whether you’re planning a day trip around Pune or a multi-day journey to destinations like Lonavala, Shirdi, or Goa, our vehicles provide superior ride quality and comfort throughout."
  },
  {
    "WhyChooseheading": "Quick Online Booking and Flexible Rental Options",
    "WhyChoosedescription": "Booking an Urbania on rent is quick and easy with Amruta Travels. Use our online booking platform or call us directly to reserve your vehicle. We offer flexible rental durations—hourly, daily, or multi-day plans—tailored to your travel needs."
  },
  {
    "WhyChooseheading": "24/7 Support and Customer Service",
    "WhyChoosedescription": "Our dedicated customer support team is available around the clock to assist with bookings, route planning, and any last-minute changes. We’re committed to delivering a smooth and dependable rental experience every time you choose Urbania with Amruta Travels."
  }
]



















    }

const faqData = [
  {
    question: 'Can I rent a Force Urbania in Pune with Amruta Travels?',
    answer: 'Yes, Amruta Travels offers the Force Urbania for rent in Pune. This luxury minibus is ideal for group travel, providing comfort and style for both local and outstation trips.',
  },
  {
    question: 'What are the seating capacities available for the Force Urbania?',
    answer: 'Amruta Travels provides Force Urbania with seating capacities of 13 and 17 seats, accommodating small to medium-sized groups comfortably.',
  },
  {
    question: 'What amenities are included in the Force Urbania?',
    answer: 'The Force Urbania is equipped with air conditioning, reclining seats, ample legroom, large luggage space, and a premium audio system, ensuring a comfortable journey.',
  },
  {
    question: 'Is a driver included with the Force Urbania rental?',
    answer: 'Yes, all rentals include an experienced and licensed driver who ensures a safe and smooth travel experience.',
  },
  {
    question: 'How much does it cost to rent a Force Urbania in Pune?',
    answer: 'The rental cost varies based on factors such as seating capacity, trip duration, and distance. For a 13-seater, rates start at ₹35 per km, while a 17-seater starts at ₹38 per km. Local packages are also available, starting at ₹7,000 for 4 hours and 35 km.',
  },
  {
    question: 'Can I rent a Force Urbania for corporate or private events?',
    answer: 'Absolutely! The Force Urbania is perfect for corporate events, weddings, family gatherings, and group tours, offering a luxurious and comfortable travel experience.',
  },
  {
    question: 'Are the Force Urbania vehicles well-maintained and sanitized?',
    answer: 'Yes, all our vehicles undergo regular maintenance and thorough sanitization before each trip to ensure the highest standards of safety and hygiene.',
  },
  {
    question: 'How do I book a Force Urbania with Amruta Travels?',
    answer: 'You can easily book a Force Urbania by contacting Amruta Travels through our website or by phone. Our team will assist you in selecting the right vehicle and finalizing your booking.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Raghav Deshmukh',
    role: 'Event Coordinator, Pune',
    text: 'We rented a 17-seater Force Urbania for a corporate retreat. The vehicle was spacious, well-maintained, and the driver was professional. It made our trip comfortable and enjoyable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Priya Joshi',
    role: 'Wedding Planner',
    text: 'The Force Urbania we rented for a wedding event was perfect. It accommodated all our guests comfortably and added a touch of luxury to the occasion.',
    rating: 5,
  },
];










































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const serviceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Urbania On Rent in Pune",
  "image": "https://bushireinpune.com/assets/images/urbania-on-rent-in-pune.jpg",
  "description":
    "Amruta Travels offers Force Urbania on rent in Pune for family trips, corporate events, picnics, and outstation travel. 17-seater luxury mini bus available across Pune.",
  
  "provider": {
    "@type": "LocalBusiness",
    "name": "Amruta Travels",
    "telephone": "+91 7353109555",
    "url": "https://bushireinpune.com"
  },

  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },

  "serviceType": "Luxury Mini Bus Rental",

  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "8100",
    "bestRating": "5",
    "worstRating": "1"
  },

  "offers": {
    "@type": "Offer",
    "url": "https://bushireinpune.com/urbania-on-rent-in-pune",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "priceSpecification": {
      "@type": "UnitPriceSpecification",
      "price": "2499",
      "unitText": "per day"
    }
  }
};

   




    return (
        <div>


 <Helmet>
      <title>
        Urbania On Rent in Pune | Luxury 17 Seater Mini Bus | Amruta Travels
      </title>

      <meta
        name="description"
        content="Book Force Urbania 17-seater luxury mini bus on rent in Pune for family trips, corporate events, weddings & tours. Service available in Kothrud, Viman Nagar, Koregaon Park & more."
      />

      <meta name="keywords" content="Urbania on rent Pune, Force Urbania Pune, mini bus rental Pune, 17 seater bus Pune, luxury bus rental Pune" />

      <meta name="robots" content="index, follow" />

      {/* Open Graph (for social sharing) */}
      <meta property="og:title" content="Urbania On Rent in Pune | Amruta Travels" />
      <meta
        property="og:description"
        content="Rent Force Urbania 17-seater luxury mini bus in Pune for trips, events & tours at affordable rates."
      />
      <meta
        property="og:image"
        content="https://bushireinpune.com/assets/images/urbania-on-rent-in-pune.jpg"
      />
      <meta property="og:url" content="https://bushireinpune.com/urbania-on-rent-in-pune" />
      <meta property="og:type" content="website" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Urbania On Rent in Pune | Amruta Travels" />
      <meta
        name="twitter:description"
        content="Luxury 17-seater Urbania available for rent in Pune. Ideal for family trips & corporate travel."
      />
      <meta
        name="twitter:image"
        content="https://bushireinpune.com/assets/images/urbania-on-rent-in-pune.jpg"
      />

      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(serviceSchema)}
      </script>
    </Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/70.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Urbaniaonrentinpune;